export const DEFAULT_SECOND_MESSAGE_TIMING = 120 + Math.round(Math.random() * 60);
export const DEFAULT_THIRD_MESSAGE_TIMING = 3 + Math.round(Math.random() * 2);
// Timing values for 4th message and onwards
export const DEFAULT_NTH_MESSAGE_TIMING = 2 + Math.round(Math.random() * 2);
